import React from 'react'

import {
  Layout,
  Header,
  SectionTitle,
  Code,
  Iconography,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <div className="intro">
          <p>
            Icons are symbols that represent concepts, objects or actions, and
            have semantic purpose within a layout. They should always be
            recognizable, functional and easily understood.
          </p>
        </div>

        <SectionTitle>Icon Font</SectionTitle>
        <p>
          Icons may be added to any inline element. To add an icon, include the{' '}
          <span class="inline__code">icon</span> class as well as the class name
          of the specific icon you want to use. Icon names reflect what the icon
          shows, not what it means, and are dash separated, e.g.{' '}
          <span class="inline__code">icon--card-in-slot</span>.
        </p>
        <Code site={data.site} class="inline__code" language="html">
          {'<i class="icon icon--bar-graph"/>'}
        </Code>
        <hr />
        <SectionTitle>Icon Sizes</SectionTitle>
        <p>
          Icons can be modified from their base size (1em) using modifier
          classes:
        </p>
        <table>
          <thead>
            <th>Class</th>
            <th>Size</th>
            <th>Example</th>
          </thead>
          <tbody>
            <tr>
              <td>(default)</td>
              <td>1em</td>
              <td>
                <i class="icon icon--exclamation"></i>
              </td>
            </tr>
            <tr>
              <td>.icon--sm</td>
              <td>.75em</td>
              <td>
                <i class="icon icon--exclamation icon--sm"></i>
              </td>
            </tr>
            <tr>
              <td>.icon--lg</td>
              <td>1.5em</td>
              <td>
                <i class="icon icon--exclamation icon--lg"></i>
              </td>
            </tr>
            <tr>
              <td>.icon--xl</td>
              <td>2em</td>
              <td>
                <i class="icon icon--exclamation icon--xl"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <hr />
        <SectionTitle>Accessibility</SectionTitle>
        <p>
          Elements with an icon class must also have an{' '}
          <span class="inline__code">aria-labelledby</span> attribute whose
          value matches that of the <span class="inline__code">id</span>{' '}
          attribute on the element with the icon's associated text label.
        </p>
        <p class="inline__code">{'<label id="check"/>Order Checks</label>'}</p>
        <br />
        <p class="inline__code l-margin-top--medium">
          {'<i aria-labelledby="check" class="icon icon--check"/>'}
        </p>
        <hr />
        <SectionTitle>Icon Library</SectionTitle>
        <Iconography site={data.site} />
      </Layout>
    </>
  )
}
